module.exports = __webpack_public_path__ + "img/malawi.b253d817.png";